export default "__VITE_ASSET__BlvBpIe2__"